@if (treatmentSteps$ | ngrxPush; as treatmentSteps) {
  <div class="flex flex-col">
    @for (
      treatmentStep of treatmentSteps;
      track trackByTreatmentStep($index, treatmentStep)
    ) {
      <pr-expandable-treatment-step
        [treatmentPlan]="treatmentPlan$ | async"
        [treatmentStep]="treatmentStep"
        [currentPractitioner]="currentPractitioner$ | async"
        [patient]="patient$ | async"
        [expanded]="false"
      >
        <pr-treatment-scope-list
          [disabled]="
            disabled
              ? disabled
              : (treatmentStep
                | pairMap$: treatmentPlan$ : isStepComplete
                | async)
          "
          [treatments]="treatmentStep.treatments"
          [step]="treatmentStep"
          [plan]="treatmentPlan$ | async"
          (treatmentsChange)="updateTreatments(treatmentStep, $event)"
        />
      </pr-expandable-treatment-step>
    }
    @if (canAddStep) {
      <div
        *prHasPermission="treatmentPlanManagePermission"
        [matTooltip]="stepDisplay.unscheduledHiddenTooltip()"
      >
        <button
          type="button"
          mat-button
          class="action-button"
          (click)="createNewStep()"
        >
          <mat-icon>add</mat-icon>
          <span class="text-xs">Add Step</span>
        </button>
      </div>
    }
  </div>
}
